export default "__VITE_ASSET__BR4Bo6KW__"